export default "__VITE_PUBLIC_ASSET__f86227b3__"